import React from 'react'
import graveyard from '../../images/graveyard.jpg'
import Mutate from './Pages/Mutate'
import Reroll from './Pages/Reroll'
import Staking from './Pages/Staking'

import {
  BrainzContainer,
  BrainzBg,
  ShopLayoutContainer,
  Text
} from './BrainzShopElements.js'

const BrainzShopPage = ({ page, address, tokens }) => {
  const renderPage = () => {
    if(address.length === 0){
      return <Text>Please Connect Wallet To Access Shop...</Text>
    }

    switch (page) {
      case 'Reroll':
         return <Reroll address={address} tokens={tokens}/>
      case 'Mutate':
        return <Mutate address={address} tokens={tokens}/>
      case 'Stake':
        return <Staking address={address}/>
      default:
        return <Text>Please Connect Wallet To Access Shop...</Text>
    }
  }

  return (
    <>
      <BrainzContainer>
        <BrainzBg src={graveyard} />
        <ShopLayoutContainer>
          {renderPage()}
        </ShopLayoutContainer>
      </BrainzContainer>
    </>
  )
}

export default BrainzShopPage

